import { format } from "date-fns";
import { TableWidgetRow } from "@hatch-digital-nl/abs-storybook/legacy";
import { EmployeeScheduledQualificationInterface } from "../../../common/interfaces/ScheduledQualificationInterface";

interface Args {
    scheduledQualifications: EmployeeScheduledQualificationInterface[];
}

export const mapScheduledQualificationsToRows = (
    args: Args,
): TableWidgetRow[] => {
    return args.scheduledQualifications.map(
        (employeeScheduledQualification) => {
            const scheduledQualification =
                employeeScheduledQualification.scheduled_qualification;

            return [
                {
                    value: scheduledQualification.qualification.name,
                },
                {
                    value: scheduledQualification.educator.name,
                },
                {
                    value: format(
                        scheduledQualification.starts_at,
                        "dd-MM-yyyy",
                    ),
                },
            ];
        },
    );
};
